<template>
    <div class="container">
        <div class="row d-flex align-items-center" style="min-height: 100vh;">
            <div class="col-12">
                <h1 class="text-center">{{$t('UNAUTHORIZED.message')}}</h1>
                <div class="d-flex justify-content-center my-4">
                    <icon name="icon-sad" fontSize="10em" color="#000"></icon>
                </div>
                <router-link tag="button" class="d-block btn btn-cph-primary mr-auto ml-auto" :to="$TYPES.ROUTES.LOGIN">{{$t('AUTH.LOGIN.loginButton')}}</router-link>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import Icon from '../../components/Shared/Icons/Icon';

export default {
    name: 'Unauthorized',
    components: {
        Icon
    },
    mounted () {
        setTimeout(() => this.$router.push({name: this.$TYPES.ROUTES.LOGIN}), 1500);
    }
};
</script>

